var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"heading"},[_c('h1',[_vm._v(_vm._s(_vm.$ml.get("My account")))]),_c('app-btn',{attrs:{"icon":"exit_to_app"},on:{"click":_vm.logOut}},[_vm._v(_vm._s(_vm.$ml.get("Logout")))])],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }